@if (permissions.canViewMoi) {
    <linked-moi-overview
        [moiType]="moiType"
        [parentGuid]="risk.guid"
        [canAdd]="permissions.canAddMoi"
        [canDelete]="permissions.canDeleteMoi"
        #linkedRiskMoisComponent
    >
    </linked-moi-overview>
}
<hr />

@if (!isLoading) {
    <app-linkable
        typename="measures of improvement of Finding Reports"
        [displayValueProp]="displayValueProp"
        [linked]="linked"
        [unlinked]="unlinked"
        [orderByValueProperty]="true"
        [disabled]="!permissions.canLinkBim"
        (onOpenClicked)="openItem($event)"
        [allowOpenItem]="true"
        [hideActions]="hideActions"
        [hideFilter]="hideFilter"
        [allowAddNew]="allowAddNew"
        [showAdvancedFilters]="showAdvancedFilters"
        [activeFilters]="activeFilters"
        [filterConfig]="filterConfig"
        (linkedChange)="linkedItemsChanged($event)"
        [moduleType]="moiModuleType"
        #linkedImMoi
    >
    </app-linkable>
}
